import React, { useState } from "react";
import "./Notification.css";

const Notification = () => {
    const [visible, setVisible] = useState(true);

    if (!visible) return null;

    return (
        <div className="notification">
            <button className="close-btn" onClick={() => setVisible(false)}></button>
            <p className="notification-title">Внимание!</p>
            <p className="notification-message">
                Внимание! Заявки обрабатываются с помощью KYC через
                операторов поддержки. После создания заявки напишите пожалуйста в чат
                поддержки для проведения обмена.
            </p>
        </div>
    );
};

export default Notification;
